import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Eye, Heart, Coins, Droplets, HandCoins } from "lucide-react";

const Tile = ({ icon: Icon, label, value, testid }) => (
  <div className="border-r border-b border-[#3a3a3a] p-4" data-testid={testid}>
    <div className="flex items-center gap-1.5 font-mono text-[10px] uppercase tracking-[0.25em] text-[#d0d0d0] mb-2">
      <Icon size={10} /> {label}
    </div>
    <div className="font-display text-2xl font-bold leading-none">{value}</div>
  </div>
);

/** Creator analytics strip for /my-coins — totals across all owned coins. */
export default function CreatorStats() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/me/analytics")
      .then(({ data }) => setStats(data.totals))
      .catch((e) => console.warn("analytics load failed", e?.message));
  }, []);

  if (!stats || stats.coins === 0) return null;

  return (
    <div className="mb-8" data-testid="creator-stats">
      <div className="font-mono text-[11px] tracking-[0.3em] uppercase text-[#d0d0d0] mb-2">
        // Analytics · all your coins
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-5 border-l border-t border-[#3a3a3a]">
        <Tile icon={Coins} label="Coins" value={stats.coins} testid="stat-coins" />
        <Tile icon={Eye} label="Views" value={(stats.views || 0).toLocaleString()} testid="stat-views" />
        <Tile icon={Heart} label="Likes" value={(stats.likes || 0).toLocaleString()} testid="stat-likes" />
        <Tile icon={HandCoins} label="Tips" value={`${(stats.tips_sol || 0).toFixed(2)} SOL`} testid="stat-tips" />
        <Tile icon={Droplets} label="On-chain / Pools" value={`${stats.minted} / ${stats.pools}`} testid="stat-onchain" />
      </div>
    </div>
  );
}
